<template>
  <div class="kChart">
    <!-- 标的弹窗 -->
    <el-dialog
      title="更换标的"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :visible.sync="symbolVisible"
      width="560px"
      class="symbolDialog"
    >
      <ul class="symbolDiaUl">
        <li>
          <label class="tit fl">类型:</label>
          <p class="fl">
            <el-select
              v-model="paramType"
              @change="onchangeSel"
              placeholder="请选择类型"
              size="small"
              style="width:200px"
            >
              <el-option label="全部" value="0"></el-option>
              <el-option label="股票" value="stock"></el-option>
              <el-option label="期货" value="future" v-if="typeSel"></el-option>
              <el-option label="指数" value="index" v-if="typeSel"></el-option>
              <el-option label="ETF" value="etf" v-if="typeSel"></el-option>
            </el-select>
          </p>
        </li>
        <li>
          <p class="tit">选择行情:</p>
          <div class="head">
            <span class="wid10">代码</span>
            <span class="wid20">证券名称</span>
          </div>
          <div style="height: 296px;">
            <ul class="symbolDiaUl-list scroll-bar scroll-bar-gray">
              <li
                v-for="(item,idx) in codeDataTOList"
                :key="idx"
                :class="{'selectLi':item.symbol==subject.symbol&&item.exchange==subject.exchange}"
                @click="selectBtn(item)"
              >
                <span class="wid10">{{item.symbol}}</span>
                <span class="wid20">{{item.name}}</span>
                <span style="width:50px;">
                  <i class="el-icon-check I-check"  v-if="item.symbol==subject.symbol&&item.exchange==subject.exchange"></i>
                </span>
              </li>
            </ul>
          </div>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="save(false)" size="mini" :disabled="!subject.exchange">取 消</el-button>
        <el-button type="primary" @click="save(true)" size="mini" :disabled="!subject.exchange">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    headerData: {
      type: Object,
      required: true
    },
     // 已选择数据
    getKsubject:{
      type: Object,
      required: true
    },
    // 是否弹窗
     symbolVisible: {
      type: Boolean,
      required: true
    },
    // 是否显示
     typeSel: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      paramType: "0",
      loading: false,
      codeDataTOList: [],
      typeInit: true,
      subject:this.getKsubject,
      getData: [],
    };
  },
  methods: {
    // 保存
    save(type){
        // this.symbolVisible = false;
        this.$emit('onSucceed',this.subject,type)
    },
    // 选择行情
    selectBtn(item){
        this.subject = item;
    },
    // 类型切换
    onchangeSel(item) {
      this.codeDataTOList =
        item == "0"
          ? this.headerData.codeDataTOList
          : this.headerData.codeDataTOList.filter(res => res.type == item);
    },
    ngOnInit() {
      this.codeDataTOList = this.headerData.codeDataTOList;
    }
  },
  deactivated() {
    this.ngOnInit();
  },
  mounted() {},
  created() {}
};
</script>
<style lang="less" scoped>
// 弹窗
.symbolDialog {
  .tit {
    color: #3f98f1;
    width: 64px;
    line-height: 30px;
    margin-right: 10px;
    line-height: 34px;
  }
  .symbolDiaUl-list {
    padding-top: 0px;
    text-align: center;
    width: 520px;
    border: 1px solid rgba(221, 221, 221, 1);
    padding-bottom: 16px;
    li:hover {
      background: #e9f4ff;
      color: #57a3ef;
    }
    li {
      height: 27px;
      line-height: 27px;
      font-size: 12px;
      font-family: MicrosoftYaHei;
      color: #666666;
      cursor: pointer;
      > span {
        float: left;
      }
    }
  }
  .wid10 {
    width: 100px;
  }
  .wid20 {
    width: 300px;
  }
  .head {
    text-align: center;
    background: #57a3ef;
    color: #fff;
    height: 27px;
    font-size: 12px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    line-height: 27px;
    > span {
      float: left;
    }
  }
  .symbolDiaUl {
    > li {
      clear: both;
      overflow: hidden;
      margin-bottom: 10px;
    }
    .I-check {
      font-size: 16px;
      color: #57a3ef;
      font-weight: 600;
    }
  }
  /deep/ .el-dialog__header {
    box-shadow: 0px 0px 4px 0px rgba(153, 153, 153, 1);
  }
  /deep/ .el-dialog__title {
    line-height: 24px;
    color: #57a3ef;
    font-size: 16px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
  }
  /deep/ .el-dialog__body {
    padding: 20px 20px 0px 20px;
  }
  .selectLi {
    background: #e9f4ff;
    color: #57a3ef;
  }
}
</style>
